import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UserDataService } from '../../../shared/services/userData.service';
import { CustomEopService } from '../../../shared/services/customEop.service';
import { SpinnerComponent } from '../../components/spinner/spinner.component';
import { NoEmojiDirective } from '../../../shared/helpers/noEmoji.directive';

@Component({
  selector: 'add-custom-page',
  standalone: true,
  imports: [CommonModule, FormsModule, SpinnerComponent, NoEmojiDirective],
  templateUrl: './add-custom-page.component.html'
})
export class AddCustomPageComponent implements OnInit {

  @Output() onClose = new EventEmitter<void>();
  @Output() onSave = new EventEmitter<any>();

  currentBuildingId: string | null = null;
  newCustomPageTitle: string = '';
  loading: boolean = false;

  constructor(
    private userDataService: UserDataService,
    private customEopService: CustomEopService
  ) {}

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
  }

  saveNewCustomPage(): void {
    if (!this.newCustomPageTitle) return;
    if (this.currentBuildingId) {
      this.loading = true;
      this.customEopService.createBuildingCustomPage(this.currentBuildingId, this.newCustomPageTitle).subscribe({
        next: () => {
          this.loading = false;
          this.onSave.emit({ type: 'success', message: 'This occurred after adding new custom page.' });
        },
        error: (error) => {
          this.loading = false;
          this.onSave.emit({ type: 'unsuccess', message: error.message });
        }
      });
    }
  }

  handleClose(): void {
    this.onClose.emit();
  }
}
